import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

// Initialize plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat); // For ordinal formatting (1st, 2nd, 3rd, etc.)

/**
 * Formats a UTC date to ET timezone with format "MONTH DAY(ordinal) AT HH(am/pm) ET"
 * @param {string} dateString - ISO format date string (e.g., "2025-05-19T22:00:00Z")
 * @return {string} - Formatted date (e.g., "MAY 19TH AT 6PM ET")
 */
export const formatDateToET = dateString => {
  return dayjs(dateString).tz('America/New_York').format('MMMM Do [AT] hA [ET]').toUpperCase();
};

// Example usage:
// formatDateToET("2025-05-19T22:00:00Z") will return "MAY 19TH AT 6PM ET"

export function formatDate(date) {
  return date.minute() === 0 ? date.format('ha') : date.format('h:mma');
}
